export const RESET = 'EXSBPAYMENTWAY_LIST_RESET'
export const SET_ITEMS = 'EXSBPAYMENTWAY_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBPAYMENTWAY_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBPAYMENTWAY_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBPAYMENTWAY_LIST_TOGGLE_LOADING'
